/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Summary_FailedInputs */

const cs_ebr_summary_failed = /** @type {(inputs: Ebr_Summary_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyby`)
};

const en_ebr_summary_failed = /** @type {(inputs: Ebr_Summary_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Ebr_Summary_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_summary_failed = /** @type {((inputs?: Ebr_Summary_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Summary_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_summary_failed(inputs)
	return cs_ebr_summary_failed(inputs)
});